import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { __bot } from 'Utils/Bot/Bot';
import { __chatQueue } from 'Utils/ChatQueue/ChatQueue';
import { __botResponse } from 'Utils/Bot/BotResponse';
import { __sb } from 'Utils/SB/sb';
import Pusher from 'pusher-js';
import { AppState } from 'Utils/Enums';
import { __callbacks } from "Utils/Callbacks/Callback";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

//initialize the bot
__bot.init();
__botResponse.init();
__chatQueue.initEvents();

//Clear all session storage data on first load
sessionStorage.clear();

//We need to clear local storage IF we are an incompatible version
if (localStorage.getItem('chatappv3') === null || localStorage.getItem('chatappv3') !== 'true') {
    localStorage.clear();
    localStorage.setItem('chatappv3', 'true');
}

//When the widget loads always send over the browser details. 
__sb.sendLocation('');

if (localStorage.getItem('last_Chat' + window.location.search.substr(1).split("&")[0].split("=")[1]) === null || localStorage.getItem('last_Chat' + window.location.search.substr(1).split("&")[0].split("=")[1]) === '0') {
} else {
    setTimeout(() => {
        __callbacks.continueConversation.trigger({
            conversationId: localStorage.getItem('last_Chat' + window.location.search.substr(1).split("&")[0].split("=")[1]),
            backState: AppState.home
        });
    }, 500);
}
